import { render, staticRenderFns } from "./chainInfo.vue?vue&type=template&id=6499e8c0&scoped=true&"
import script from "./chainInfo.vue?vue&type=script&lang=js&"
export * from "./chainInfo.vue?vue&type=script&lang=js&"
import style0 from "./chainInfo.vue?vue&type=style&index=0&id=6499e8c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499e8c0",
  null
  
)

export default component.exports